module.exports = __webpack_public_path__ + "static/img/pcad2.33a1c949.png";